<template>
  <router-view />
</template>

<script>
export default {
  name: 'ExamsIndex'
}
</script>
